import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useLocation } from 'react-router'

import { useCustomTranslation } from '../../../infrastructure/translation/useCustomTranslation'
import { t } from '../../../infrastructure/translation/customTranslation'
import { useStore } from '../../../application/store/store'
import { SpanUnselect, Title, Wrapper, Subtitle } from './plantSearch.styles'

const getTitle = (location: string): string => {
  switch (location) {
    case '/':
      return t('overview')
    case '/documents':
      return t('documents')
    case '/facturation':
      return t('invoice')
    case '/plant-select':
      return t('central_selection')
    case '/cgu':
      return t('cgu', 'uppercase')
    default:
      return t('overview')
  }
}
export const MobilePlantSearchSelected = (): React.ReactElement => {
  const location = useLocation()
  const { selectedPlant, unsetPlantSelected } = useStore()
  const title = getTitle(location.pathname)
  const isPageCentrale = !(location.pathname === '/cgu')
  const { t: customTrans } = useCustomTranslation('common')
  return (
    <Wrapper>
      <Title>{title}</Title>
      {isPageCentrale && (
        <>
          {selectedPlant ? (
            <Subtitle>
              {`${selectedPlant.nom}`}
              <SpanUnselect role="button" onClick={unsetPlantSelected}>
                <FontAwesomeIcon icon="times" />
              </SpanUnselect>
            </Subtitle>
          ) : (
            <Subtitle>{customTrans('all_plants')}</Subtitle>
          )}
        </>
      )}
    </Wrapper>
  )
}
